// Product-related translations
const productsTranslations = {
    product_master_title: {
        th: "Product Master",
        en: "Product Master",
        ja: "商品マスター",
    },
    product_master: {
        th: "Product Master",
        en: "Product Master",
        ja: "商品マスター",
    },
    product_url: {
        th: "Product URL",
        en: "Product URL",
        ja: "商品URL",
    },
    product_status: {
        th: "สถานะ",
        en: "Status",
        ja: "ステータス",
    },
    product_status_draft: {
        th: "draft",
        en: "draft",
        ja: "下書き",
    },
    product_status_editing: {
        th: "editing",
        en: "editing",
        ja: "編集中",
    },
    product_status_released: {
        th: "released",
        en: "released",
        ja: "公開",
    },
    product_status_duplicated: {
        th: "duplicated",
        en: "duplicated",
        ja: "重複",
    },
    product_status_rejected: {
        th: "rejected",
        en: "rejected",
        ja: "却下",
    },
    product_status_dummy: {
        th: "dummy",
        en: "dummy",
        ja: "ダミー",
    },
    product_status_brand: {
        th: "brand",
        en: "brand",
        ja: "ブランド",
    },
    product_name: {
        th: "ชื่อสินค้า",
        en: "Product Name",
        ja: "商品名",
    },
    image_path: {
        th: "Image Path",
        en: "Image Path",
        ja: "画像パス",
    },
    product_price: {
        th: "ราคา",
        en: "Price",
        ja: "価格",
    },
    product_price_unit: {
        th: "หน่วยราคา",
        en: "Price Unit",
        ja: "価格単位",
    },
    product_unit: {
        th: "หน่วย",
        en: "Unit",
        ja: "単位",
    },
    product_description: {
        th: "คำอธิบาย",
        en: "Description",
        ja: "説明",
    },
    product_category: {
        th: "หมวดหมู่",
        en: "Category",
        ja: "カテゴリ",
    },
    select_category: {
        th: "เลือกหมวดหมู่...",
        en: "Select category...",
        ja: "カテゴリを選択...",
    },
    product_brand: {
        th: "แบรนด์",
        en: "Brand",
        ja: "ブランド",
    },
    product_country: {
        th: "ประเทศ",
        en: "Country",
        ja: "国",
    },
    product_price_unit_combined: {
        th: "ราคา / หน่วย",
        en: "Price / Unit",
        ja: "価格 / 単位",
    },
    product_average_rating: {
        th: "คะแนนเฉลี่ย",
        en: "Average rating",
        ja: "平均評価",
    },
    product_keyword: {
        th: "คีย์เวิร์ด",
        en: "Keyword",
        ja: "キーワード",
    },
    product_note: {
        th: "บันทึก",
        en: "Note",
        ja: "メモ",
    },
    product_group_id: {
        th: "รหัสกลุ่ม",
        en: "Group ID",
        ja: "グループID",
    },
    product_how_to_use: {
        th: "วิธีใช้",
        en: "How to use",
        ja: "使い方",
    },
    product_ingredients: {
        th: "ส่วนผสม",
        en: "Ingredients",
        ja: "成分",
    },
    product_review_summary: {
        th: "AI สรุปรีวิว",
        en: "AI Review Summary",
        ja: "AI レビュー要約",
    },
    product_review_summary_th: {
        th: "สรุปรีวิว (ไทย)",
        en: "Review Summary (th)",
        ja: "レビュー要約（タイ語）",
    },
    product_review_summary_en: {
        th: "สรุปรีวิว (อังกฤษ)",
        en: "Review Summary (en)",
        ja: "レビュー要約（英語）",
    },
    product_review_summary_ja: {
        th: "สรุปรีวิว (ญี่ปุ่น)",
        en: "Review Summary (ja)",
        ja: "レビュー要約（日本語）",
    },
    product_review_summary_positive_keyword: {
        th: "คีย์เวิร์ด",
        en: "Keywords",
        ja: "キーワード",
    },
    product_review_summary_negative_keyword: {
        th: "คีย์เวิร์ด",
        en: "Keywords",
        ja: "キーワード",
    },
    product_review_summary_summary: {
        th: "สรุป",
        en: "Summary",
        ja: "要約",
    },
    product_review_summary_keyword_placeholder: {
        th: "เพิ่มคีย์เวิร์ด",
        en: "Add keyword",
        ja: "キーワードを追加",
    },
    add_keyword: {
        th: "เพิ่มคีย์เวิร์ด",
        en: "Add keyword",
        ja: "キーワードを追加",
    },
    product_manual_score_offset: {
        th: "คะแนนออฟเซต",
        en: "Score Offset",
        ja: "スコアオフセット",
    },
    manual_score_offset_note: {
        th: "คะแนนออฟเซตที่เพิ่มเข้าไปในคะแนนเมตริกรายเดือนของสินค้า\n0: ไม่มีการเปลี่ยนแปลง (ค่าเริ่มต้น)\n10: บูสต์เล็กน้อย\n30: รักษาอันดับสูงแม้ไม่มีรีวิวในเดือนนั้น\n50: ตรึงสินค้าหลักให้อยู่ในอันดับต้น\n80-100: สินค้าสำคัญสูงสุด (แสดงผลตลอด)",
        en: "Score offset added to the product's monthly metric value.\n0: No change (default)\n10: Minor boost\n30: Maintain high rank even with zero reviews that month\n50: Pin main products to top\n80-100: Top-priority products (always visible)",
        ja: "商品の月次メトリック値に加算するオフセット。\n0: 変更なし（デフォルト）\n10: マイナーブースト\n30: 当月レビューゼロでも上位維持\n50: 主力商品を安定上位に固定\n80〜100: 最重要商品（常時表示）",
    },
    product_image_methods_note: {
        th: "มี 3 วิธีในการตั้งค่ารูปภาพสินค้า:\n1. กรอก ‘Product URL’ (ระบบจะใส่ภาพ OGP ให้อัตโนมัติ)\n2. วาง URL ของรูปภาพลงใน ‘Image Path’\n3. เลือกรูปผ่านปุ่ม ‘Change Image’ (อัปโหลดอัตโนมัติ)",
        en: "There are 3 ways to set the product image:\n1. Enter ‘Product URL’ (OGP image will be auto inserted)\n2. Paste an image URL into ‘Image Path’\n3. Select a file via the ‘Change Image’ button (auto upload)",
        ja: "商品画像の設定方法は3通りあります：\n1. ‘Product URL’ を入力（OGP画像が自動挿入されます）\n2. ‘Image Path’ に画像URLを入力\n3. ‘画像を変更’ ボタンでファイル選択（自動アップロード）",
    },
    product_label_discover: {
        th: "ค้นพบสินค้าที่คุณชื่นชอบและแชร์รีวิวของคุณ",
        en: "Find your favorites and share your honest review",
        ja: "お気に入りを見つけて、あなたのレビューを投稿しよう",
    },
    product_search_placeholder: {
        th: "ค้นหาสินค้า...",
        en: "Search products...",
        ja: "商品を検索...",
    },
    search_button: {
        th: "ค้นหา",
        en: "Search",
        ja: "検索",
    },
    confirm: {
        th: "ยืนยัน",
        en: "Confirm",
        ja: "確定",
    },
    clear: {
        th: "ล้าง",
        en: "Clear",
        ja: "クリア",
    },
    // Rating labels
    rating_poor: {
        th: "แย่",
        en: "Poor",
        ja: "悪い",
    },
    rating_excellent: {
        th: "ยอดเยี่ยม",
        en: "Excellent",
        ja: "優秀",
    },
    // Product fields
    products_price: {
        th: "ราคา",
        en: "Price",
        ja: "価格",
    },
    products_category: {
        th: "หมวดหมู่",
        en: "Category",
        ja: "カテゴリ",
    },
    products_brand: {
        th: "แบรนด์",
        en: "Brand",
        ja: "ブランド",
    },
    product_id: {
        th: "รหัสสินค้า",
        en: "Product ID",
        ja: "商品ID",
    },
    products_product_list: {
        th: "รายการสินค้า",
        en: "Product List",
        ja: "商品一覧",
    },
    products_trending_title: {
        th: "สินค้าแนะนำ",
        en: "Trending Products",
        ja: "トレンド商品",
    },
    products_trending_subtitle: {
        th: "สินค้าที่เราแนะนำสำหรับคุณ",
        en: "Our most recommended products",
        ja: "おすすめの商品をご紹介します",
    },
    product_list_image_zoom: {
        th: "ซูมภาพ",
        en: "Image Zoom",
        ja: "画像ズーム",
    },
    products_product_details: {
        th: "รายละเอียดสินค้า",
        en: "Product Details",
        ja: "商品詳細",
    },
    product_label_description: {
        th: "รายละเอียด",
        en: "Description",
        ja: "説明",
    },
    "product-catalog": {
        th: "รีวิวเครื่องสำอางและสกินแคร์",
        en: "Beauty Reviews and Cosmetics",
        ja: "コスメ・スキンケアレビュー",
    },
    "search-results": {
        th: "ผลการค้นหา",
        en: "Search Results",
        ja: "検索結果",
    },
    search_no_results: {
        th: "ไม่พบข้อมูล",
        en: "No results found",
        ja: "該当する結果がありません",
    },

    // Product information labels
    product_info: {
        th: "ข้อมูลสินค้า",
        en: "Product Information",
        ja: "商品情報",
    },
    price: {
        th: "ราคา:",
        en: "Price:",
        ja: "価格:",
    },
    category: {
        th: "หมวดหมู่:",
        en: "Category:",
        ja: "カテゴリ:",
    },
    brand: {
        th: "แบรนด์:",
        en: "Brand:",
        ja: "ブランド:",
    },

    // Review related
    write_review: {
        th: "เขียนรีวิว",
        en: "Write a Review",
        ja: "レビューを書く",
    },
    reviews: {
        th: "รีวิว",
        en: "Reviews",
        ja: "レビュー",
    },
    products: {
        th: "สินค้า",
        en: "Products",
        ja: "商品",
    },
    customer_reviews: {
        th: "รีวิวจากลูกค้า",
        en: "Customer Reviews",
        ja: "カスタマーレビュー",
    },
    sns_reviews: {
        th: "รีวิว SNS",
        en: "SNS Reviews",
        ja: "SNS レビュー",
    },
    no_reviews_yet: {
        th: "ไม่มีรีวิว",
        en: "No reviews",
        ja: "未レビュー",
    },
    no_categorized: {
        th: "ไม่มีหมวดหมู่",
        en: "No categorized",
        ja: "カテゴリなし",
    },
    no_brand: {
        th: "ไม่มีแบรนด์",
        en: "No brand",
        ja: "ブランドなし",
    },

    // Show more/less
    show_more: {
        th: "แสดงเพิ่มเติม",
        en: "Show More",
        ja: "もっと見る",
    },
    show_less: {
        th: "แสดงน้อยลง",
        en: "Show Less",
        ja: "折りたたむ",
    },

    // Advanced search (ISS:04-037)
    advanced_search: {
        th: "ค้นหาขั้นสูง",
        en: "Advanced Search",
        ja: "高度検索",
    },
    new_only: {
        th: "เฉพาะสินค้าใหม่",
        en: "New arrivals only",
        ja: "新着のみ",
    },
    recommend_only: {
        th: "เฉพาะสินค้าแนะนำ",
        en: "Recommended only",
        ja: "おすすめのみ",
    },
    ranking_only: {
        th: "เฉพาะอันดับนิยม",
        en: "Ranking only",
        ja: "ランキングのみ",
    },
    reviewed_only: {
        th: "เฉพาะที่มีรีวิว",
        en: "Reviewed only",
        ja: "レビューありのみ",
    },
    exclude_text_only: {
        th: "ยกเว้นโพสต์ข้อความล้วน",
        en: "Exclude text only",
        ja: "テキストのみを除外",
    },
    scored_only: {
        th: "เฉพาะที่มีคะแนนออฟเซต",
        en: "Scored only",
        ja: "スコア設定済みのみ",
    },
    brand_video_posts: {
        th: "วิดีโอแนะนำ",
        en: "Videos",
        ja: "動画紹介",
    },
    sort_by_latest_review: {
        th: "เรียงตามรีวิวล่าสุด",
        en: "Latest review",
        ja: "投稿新着順",
    },
    sort_by_product_new: {
        th: "เรียงตามสินค้าใหม่",
        en: "Newest product",
        ja: "商品新着順",
    },

    // Recommend modal (ISS-04-047)
    product_recommend_rank_title: {
        th: "อันดับแนะนำ",
        en: "Recommend rank",
        ja: "おすすめ順位",
    },
    entity_product: {
        th: "สินค้า",
        en: "Product",
        ja: "商品",
    },
    remove: {
        th: "ลบ",
        en: "Remove",
        ja: "削除",
    },
    remove_all: {
        th: "ลบทั้งหมด",
        en: "Remove All",
        ja: "すべて解除",
    },
    product_recommend_unset: {
        th: "ยกเลิก",
        en: "Unset",
        ja: "解除",
    },
    product_recommend_close: {
        th: "ปิด",
        en: "Close",
        ja: "閉じる",
    },
    product_recommend_tooltip: {
        th: "สินค้าแนะนำ",
        en: "Recommended product",
        ja: "おすすめ商品",
    },
    product_recommend_error_load: {
        th: "โหลดข้อมูลแนะนำไม่สำเร็จ",
        en: "Failed to load recommend info",
        ja: "おすすめ情報の取得に失敗しました",
    },
    product_recommend_error_update: {
        th: "อัปเดตอันดับแนะนำไม่สำเร็จ",
        en: "Failed to update recommend rank",
        ja: "おすすめ順位の更新に失敗しました",
    },
    product_recommend_error_unset: {
        th: "ยกเลิกการแนะนำไม่สำเร็จ",
        en: "Failed to unset recommend",
        ja: "おすすめの解除に失敗しました",
    },
    product_recommend_remove_all_confirm: {
        th: "ลบอันดับแนะนำทั้งหมดหรือไม่?",
        en: "Remove all recommended ranks?",
        ja: "おすすめ順位をすべて解除しますか？",
    },
    product_recommend_error_remove: {
        th: "ลบอันดับแนะนำทั้งหมดไม่สำเร็จ",
        en: "Failed to remove recommends",
        ja: "おすすめの全解除に失敗しました",
    },
    advanced_search_options: {
        th: "ตัวเลือก",
        en: "Options",
        ja: "オプション",
    },
    advanced_search_options_placeholder: {
        th: "เลือกตัวเลือก",
        en: "Select options",
        ja: "オプションを選択",
    },
    content_search: {
        th: "คีย์เวิร์ด",
        en: "Keyword",
        ja: "キーワード",
    },
    content_search_placeholder: {
        th: "ค้นหา...",
        en: "Search...",
        ja: "検索...",
    },
    content_search_fields: {
        th: "ฟิลด์เป้าหมาย",
        en: "Target Field",
        ja: "対象フィールド",
    },
    content_search_fields_placeholder: {
        th: "เลือกฟิลด์...",
        en: "Select fields...",
        ja: "対象を選択...",
    },
    price_range: {
        th: "ช่วงราคา",
        en: "Price Range",
        ja: "価格帯",
    },
    price_range_placeholder: {
        th: "เลือกช่วงราคา...",
        en: "Select price range...",
        ja: "価格帯を選択...",
    },
    price_range_unset: {
        th: "ราคายังไม่ได้กำหนด",
        en: "Price not set",
        ja: "価格未設定",
    },
    rating: {
        th: "คะแนน",
        en: "Rating",
        ja: "評価",
    },
    rating_placeholder: {
        th: "เลือกคะแนน",
        en: "Select rating",
        ja: "評価を選択",
    },
    search_conditions_save: {
        th: "บันทึก",
        en: "Save",
        ja: "保存",
    },
    search_target: {
        th: "เป้าหมาย",
        en: "Target",
        ja: "対象",
    },
    search_target_products: {
        th: "สินค้า",
        en: "Products",
        ja: "商品",
    },
    search_target_posts: {
        th: "โพสต์",
        en: "Posts",
        ja: "投稿",
    },
    search_in_description: {
        th: "คำอธิบาย",
        en: "Description",
        ja: "説明",
    },
    search_in_title: {
        th: "ชื่อเรื่อง",
        en: "Title",
        ja: "タイトル",
    },
    search_in_content: {
        th: "เนื้อหา",
        en: "Content",
        ja: "本文",
    },
    search_in_product_name: {
        th: "ชื่อสินค้า",
        en: "Product Name",
        ja: "商品名",
    },
    search_in_how_to_use: {
        th: "วิธีใช้",
        en: "How to use",
        ja: "使い方",
    },
    search_in_ingredients: {
        th: "ส่วนผสม",
        en: "Ingredients",
        ja: "成分",
    },
    updated_by: {
        th: "อัปเดตโดย",
        en: "Updated by",
        ja: "更新者",
    },
    updated_at: {
        th: "อัปเดตเมื่อ",
        en: "Updated at",
        ja: "更新日時",
    },
    updated_at_from: {
        th: "อัปเดตตั้งแต่",
        en: "Updated from",
        ja: "更新日時（開始）",
    },
    updated_at_to: {
        th: "อัปเดตถึง",
        en: "Updated to",
        ja: "更新日時（終了）",
    },

    // Search type labels for suggestions
    search_type_brand: {
        th: "แบรนด์",
        en: "Brand",
        ja: "ブランド",
    },
    search_type_product: {
        th: "สินค้า",
        en: "Product",
        ja: "商品",
    },
    search_type_category: {
        th: "หมวดหมู่",
        en: "Category",
        ja: "カテゴリ",
    },
    search_type_user: {
        th: "ผู้ใช้",
        en: "User",
        ja: "ユーザー",
    },
    search_type_post_title: {
        th: "โพสต์",
        en: "Post",
        ja: "投稿",
    },
    search_type_hashtag: {
        th: "แฮชแท็ก",
        en: "Hashtag",
        ja: "ハッシュタグ",
    },
    search_type_search_type: {
        th: "ประเภทการค้นหา",
        en: "Search Type",
        ja: "検索タイプ",
    },

    // Brand list page
    brands_list: {
        th: "แบรนด์ความงาม",
        en: "Beauty Brands",
        ja: "美容ブランド一覧",
    },
    brands_popular_title: {
        th: "แบรนด์ยอดนิยมบน Vanilla",
        en: "Popular Brands on Vanilla",
        ja: "Vanilla人気ブランド",
    },
    brands_popular_subtitle: {
        th: "แบรนด์ที่เราแนะนำสำหรับคุณ",
        en: "Our most recommended brands",
        ja: "おすすめのブランドをご紹介します",
    },
    brands_description: {
        th: "ค้นพบแบรนด์ความงามที่น่าทึ่งจากทั่วโลก",
        en: "Discover amazing beauty brands from around the world",
        ja: "世界中の素晴らしい美容ブランドを発見しよう",
    },
    filter_by_initial: {
        th: "กรองตามอักษรเริ่มต้น:",
        en: "Filter by Initial:",
        ja: "頭文字で絞り込む:",
    },
    filter_by_country: {
        th: "กรองตามประเทศ:",
        en: "Filter by Country:",
        ja: "国で絞り込む:",
    },
    filter_by_rating: {
        th: "กรองตามคะแนน:",
        en: "Filter by Rating:",
        ja: "評価で絞り込む:",
    },
    filter_all: {
        th: "หมด",
        en: "All",
        ja: "すべて",
    },
    search_brand: {
        th: "ค้นหาแบรนด์:",
        en: "Search Brand:",
        ja: "ブランド検索:",
    },
    search_category: {
        th: "ค้นหาหมวดหมู่:",
        en: "Search Category:",
        ja: "カテゴリ検索:",
    },
    search_brand_placeholder: {
        th: "ค้นหาแบรนด์...",
        en: "Search brands...",
        ja: "ブランドを検索...",
    },
    search_category_placeholder: {
        th: "ค้นหาหมวดหมู่...",
        en: "Search categories...",
        ja: "カテゴリを検索...",
    },
    no_brands_found: {
        th: "ไม่พบแบรนด์ที่ตรงกับตัวกรอง",
        en: "No brands found matching your filters.",
        ja: "条件に一致するブランドが見つかりませんでした。",
    },
    no_products_found: {
        th: "ไม่พบสินค้าที่ตรงกับตัวกรอง",
        en: "No products found matching your filters.",
        ja: "条件に一致する商品が見つかりませんでした。",
    },
    product_search_ask_messenger: {
        th: "หาสินค้าที่ต้องการไม่เจอใช่ไหม? สอบถามเราได้ทาง Messenger",
        en: "Can't find what you're looking for? Ask us on Messenger.",
        ja: "お探しの商品が見つかりませんか?Messengerでお問い合わせください。",
    },
    search_brand_fallback_before: {
        th: "หาสินค้าที่ต้องการไม่เจอใช่ไหม? เลือกแบรนด์ ",
        en: "Can't find the exact product? Select brand ",
        ja: "お探しの商品が見つかりませんか?ブランド「",
    },
    search_brand_fallback_after: {
        th: " แทน",
        en: " instead.",
        ja: "」を代わりに選択してください。",
    },
    search_brand_fallback_badge: {
        th: "NOT FOUND",
        en: "NOT FOUND",
        ja: "NOT FOUND",
    },
    no_reviews_found: {
        th: "ยังไม่มีรีวิวสำหรับสินค้านี้",
        en: "No reviews yet for this product.",
        ja: "この商品にはまだレビューがありません。",
    },
    sns_reviews_subtitle: {
        th: "รีวิว SNS ล่าสุดจากคอมมูนิตี้ Vanilla",
        en: "The latest SNS reviews from the Vanilla community",
        ja: "Vanilla コミュニティによる最新の SNS レビュー",
    },
    buy_on_shopee: {
        th: "ซื้อบน Shopee",
        en: "Buy on Shopee",
        ja: "Shopee で購入",
    },
    buy_on_lazada: {
        th: "ซื้อบน Lazada",
        en: "Buy on Lazada",
        ja: "Lazada で購入",
    },
};

export { productsTranslations };
